import { render } from "./PostSearchCriteria.vue?vue&type=template&id=5a9dda50"
import script from "./PostSearchCriteria.vue?vue&type=script&lang=js"
export * from "./PostSearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__